module.exports = __webpack_public_path__ + "static/media/28.52d77c24.webp";